import { type Theme, alpha } from '@mui/material/styles';

import type { ChecklistCategory } from './types';

export const CAMPAIGN_ASSESSMENTS_URL =
  'https://aussiecommerce.atlassian.net/wiki/spaces/SO/pages/2629074945/Campaign+Assessments';

export const CHECKLIST_FLASH_HOTELS_URL =
  'https://aussiecommerce.atlassian.net/wiki/spaces/SO/pages/2395471912/Checklist+Flash+Hotels';

export const CHECKLIST_STATUS_STYLES = {
  approvedRow: (theme: Theme) => ({
    '& td': {
      bgcolor: alpha(theme.palette.success.light, 0.06),
    },
  }),
  approvalOverviewCard: {
    bgcolor: 'warning.50',
    borderColor: 'warning.light',
  },
  approvalQueueCard: {
    bgcolor: 'warning.50',
    borderColor: 'warning.main',
  },
} as const;

export const CM_CHECKLIST_CATEGORIES: Array<ChecklistCategory> = [
  {
    description: 'Offer setup, account, ABN, currency, and contract-template checks.',
    id: 'setup',
    label: 'Setup',
  },
  {
    description: 'Campaign configuration and schedule coverage checks.',
    id: 'campaign',
    label: 'Campaign',
  },
  {
    description: 'Offer discount and margin checks.',
    id: 'discountsMargin',
    label: 'Discounts & Margin',
  },
  {
    description: 'Tax, payment-term, and settlement checks.',
    id: 'taxesPayments',
    label: 'Taxes & Payments',
  },
  {
    description: 'Deal option, package, and inclusion checks.',
    id: 'dealOptionsInclusions',
    label: 'Deal Options & Inclusions',
  },
  {
    description: 'Room asset details, capacity, and allocation consistency checks.',
    id: 'rooms',
    label: 'Rooms',
  },
  {
    description: 'Surcharge configuration and overlap checks.',
    id: 'surcharges',
    label: 'Surcharges',
  },
  {
    description: 'Blackout-date completeness and visibility checks.',
    id: 'blackoutDates',
    label: 'Blackout Dates',
  },
  {
    description: 'Extra guest surcharge margin and capacity checks.',
    id: 'egs',
    label: 'EGS',
  },
  {
    description: 'Bundled experience configuration and child-age checks.',
    id: 'bundledExperiences',
    label: 'Bundled Experiences',
  },
];
